module.exports = __webpack_public_path__ + "img/pdf.5d7dc93b.png";